import React from 'react';
import styles from './Card.module.css';

const Card = (props) => {
    return (
        <div className={styles.pageWrapper}>
            <div className={styles.cardContainer}>
                <div className={styles.card} style={ props.cardStyle ? props.cardStyle : null}>
                    <h1 className={styles.heading}>{props.header}</h1>
                    <h2 className={styles.subHeading}>
                        {props.subject}
                    </h2>
                    <p className={styles.paragraph}>
                        {props.children}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Card;
